module.exports = __webpack_public_path__ + "static/media/TP_CC (Malaruhat).b2b7d247.png";